export default "__VITE_ASSET__5b74e8aa__"